<template>
  <div
    class="app-wrapper"
    :class="classObj"
  >
    <el-container>
      <el-aside :width="'unset'">
        <!-- see node_modules/element-ui/packages/aside/src/main.vue -->
        <sidebar class="sidebar-container" />
      </el-aside>
      <el-container>
        <el-header>
          <NavbarView />
        </el-header>
        <app-main />
      </el-container>
    </el-container>

    <!-- Luce, joignable depuis n'importe quel écran sans le quitter.
         Le composant ne rend rien sans la permission `use ai chat`. -->
    <LuceLauncher />
  </div>
</template>
<script>
// import RightPanel from '@/components/RightPanel';
import { AppMain, Sidebar } from "./components";
import { mapGetters } from "vuex";
import { NavbarView } from '@/layout/components';
import LuceLauncher from '@/components/Luce/LuceLauncher.vue';

const AUTO_COLLAPSE_WIDTH = 1200;

export default {
    name: "LayoutView",
    components: {
    AppMain,
    Sidebar,
    NavbarView,
    LuceLauncher,
},
    data() {
        return {
            autoCollapsed: false,
        };
    },
    computed: {
        ...mapGetters(["sidebar"]),
        classObj() {
            return {
                hideSidebar: !this.sidebar.opened,
                openSidebar: this.sidebar.opened,
                sidebarcollapsed: !this.sidebar.opened,
            };
        }
    },
    mounted() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        handleResize() {
            const narrow = window.innerWidth < AUTO_COLLAPSE_WIDTH;
            if (narrow && this.sidebar.opened) {
                this.$store.dispatch('app/closeSideBar', { withoutAnimation: true });
                this.autoCollapsed = true;
            } else if (!narrow && this.autoCollapsed && !this.sidebar.opened) {
                this.$store.dispatch('app/toggleSideBar');
                this.autoCollapsed = false;
            }
        },
    },
};
</script>


<style>
  .el-header {
    /* background-color: #B3C0D1;
    color: #333;
    text-align: center; */
    height: 50px;
    z-index: 10;
  }

</style>
